import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/20">
                <i className="ri-flower-line text-lg text-white"></i>
              </div>
              <span className="text-lg font-semibold text-white">樱花漫画网</span>
            </div>
            <p className="text-sm text-white/70 leading-relaxed">
              免费漫画在线阅读平台，海量韩漫、日漫、国漫，随时随地免费看，追更不花一分钱。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/15 hover:bg-white/25 transition-colors">
                <i className="ri-wechat-line text-white"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/15 hover:bg-white/25 transition-colors">
                <i className="ri-weibo-line text-white"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/15 hover:bg-white/25 transition-colors">
                <i className="ri-bilibili-line text-white"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">漫画分类</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/category/korean" className="text-sm text-white/70 hover:text-white transition-colors">
                  免费韩漫
                </Link>
              </li>
              <li>
                <Link to="/category/japanese" className="text-sm text-white/70 hover:text-white transition-colors">
                  免费日漫
                </Link>
              </li>
              <li>
                <Link to="/category/chinese" className="text-sm text-white/70 hover:text-white transition-colors">
                  免费国漫
                </Link>
              </li>
              <li>
                <Link to="/" className="text-sm text-white/70 hover:text-white transition-colors">
                  热门推荐
                </Link>
              </li>
              <li>
                <Link to="/" className="text-sm text-white/70 hover:text-white transition-colors">
                  最新更新
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-white/70 hover:text-white transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-white/70 hover:text-white transition-colors">
                  用户协议
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-white/70 hover:text-white transition-colors">
                  隐私政策
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-white/70 hover:text-white transition-colors">
                  版权声明
                </a>
              </li>
              <li>
                <Link to="/about" className="text-sm text-white/70 hover:text-white transition-colors">
                  联系我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">联系方式</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-white/70">
                <i className="ri-mail-line"></i>
                <span>contact@sakuramanga.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-white/70">
                <i className="ri-phone-line"></i>
                <span>020-8888-6666</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-white/70">
                <i className="ri-map-pin-line"></i>
                <span>广州市天河区太古汇1座</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-sm text-white/60">
            &copy; 2026 樱花漫画网. All rights reserved.
          </p>
          <p className="text-sm text-white/60">
            免费漫画 · 免费看漫画 · 随时随地
          </p>
        </div>
      </div>
    </footer>
  );
}